import React from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const CTASection = ({ company, onStartRegistration }) => {
  return (
    <div className="bg-gradient-to-r from-primary to-secondary py-16 lg:py-20">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/20 rounded-full mb-6">
          <Icon name="Sparkles" size={20} color="white" />
          <span className="text-sm font-medium text-white">Ready to get started?</span>
        </div>
        
        <h2 className="text-3xl lg:text-4xl font-bold text-white mb-4">
          Begin Your Journey with {company?.name}
        </h2>
        
        <p className="text-lg text-white/90 mb-8 max-w-2xl mx-auto">
          Complete your registration in just a few minutes and join our growing team of innovators and problem solvers
        </p>
        
        <div className="flex flex-wrap justify-center gap-4">
          <Button 
            variant="default"
            size="lg"
            iconName="ArrowRight"
            iconPosition="right"
            onClick={onStartRegistration}
            className="bg-white text-primary hover:bg-white/90 shadow-xl"
          >
            Start Registration Now
          </Button>
          
          <Button 
            variant="outline"
            size="lg"
            iconName="HelpCircle"
            iconPosition="left"
            className="border-white text-white hover:bg-white/10"
          >
            Need Help?
          </Button>
        </div>
        
        <div className="flex items-center justify-center gap-8 mt-12 pt-8 border-t border-white/20">
          <div className="text-center">
            <p className="text-2xl font-bold text-white">&lt; 5 min</p>
            <p className="text-sm text-white/80">Average completion time</p>
          </div>
          
          <div className="w-px h-12 bg-white/20"></div>
          
          <div className="text-center">
            <p className="text-2xl font-bold text-white">100%</p>
            <p className="text-sm text-white/80">Secure & confidential</p>
          </div>
          
          <div className="w-px h-12 bg-white/20"></div>
          
          <div className="text-center">
            <p className="text-2xl font-bold text-white">24/7</p>
            <p className="text-sm text-white/80">Support available</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CTASection;